import type { ReactElement } from 'react'
import { cloneElement } from 'react'

import { FormControl, type IFormikFormControlProps } from './FormControl'
import { type ISelectProps } from '@ui/elements/Select'

export interface IWithFormControlSelect extends Omit<
  IFormikFormControlProps,
  'children'
> {
  id: string
  name: string
  children: ReactElement<ISelectProps>
}

export const WithFormControlSelect = ({
  name,
  disabled,
  id,
  label,
  labelIcon,
  labelBadge,
  labelTooltipMessage,
  labelTooltipAriaLabel,
  helperText,
  required,
  fullWidth = true,
  error,
  children,
}: IWithFormControlSelect) => {
  const inputId = `${id}-select-input`

  return (
    <FormControl
      name={name}
      disabled={disabled}
      id={id}
      labelFor={inputId}
      label={label}
      labelIcon={labelIcon}
      labelBadge={labelBadge}
      labelTooltipMessage={labelTooltipMessage}
      labelTooltipAriaLabel={labelTooltipAriaLabel}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
      error={error}
    >
      {({ value, handleChange, handleBlur, isSubmitting, error: hasError }) => {
        return cloneElement(children, {
          id,
          inputId,
          name,
          value,
          onChange: children.props.onChange
            ? children.props.onChange
            : (newValue, action) => {
                handleChange(newValue)
              },
          onBlur: handleBlur,
          error: hasError,
          isDisabled: isSubmitting || disabled || children.props.isDisabled,
        })
      }}
    </FormControl>
  )
}
